// frontend/src/components/CampaignManager/tabs/CallcentersTab.tsx
import React from 'react';
import {
  Box, Button, Stack, Typography,
  TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper,
  IconButton, Chip, useMediaQuery, useTheme
} from '@mui/material';
import { Plus, PencilSimple, Trash } from '@phosphor-icons/react';
import { Callcenter } from '../types';

interface Props {
  callcenters: Callcenter[];
  deleteCallcenter: (id: number) => Promise<void>;
  onOpenCallcenterDialog: (callcenter: Callcenter | null) => void;
}

export default function CallcentersTab({
  callcenters,
  deleteCallcenter,
  onOpenCallcenterDialog
}: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDeleteCallcenter = async (id: number) => {
    if (window.confirm('Callcenter wirklich löschen?')) {
      await deleteCallcenter(id);
    }
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h6">Callcenter</Typography>
        <Button
          variant="contained"
          size={isMobile ? 'small' : 'medium'}
          startIcon={<Plus size={20} />}
          onClick={() => onOpenCallcenterDialog(null)}
          sx={{ backgroundColor: '#003366' }}
        >
          {isSmallMobile ? 'Neu' : 'Neues Callcenter'}
        </Button>
      </Stack>

      {callcenters.length === 0 ? (
        <Paper variant="outlined" sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">Keine Callcenter vorhanden</Typography>
        </Paper>
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table size={isMobile ? 'small' : 'medium'}>
            <TableHead>
              <TableRow>
                <TableCell>Kürzel</TableCell>
                <TableCell>Name</TableCell>
                {!isMobile && <TableCell>WKZ-Ziffer</TableCell>}
                <TableCell>Status</TableCell>
                <TableCell align="right">Aktionen</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {callcenters.map((cc) => (
                <TableRow key={cc.id} hover>
                  <TableCell>
                    <Chip label={cc.name_kurz} size="small" />
                  </TableCell>
                  <TableCell><strong>{cc.name}</strong></TableCell>
                  {!isMobile && (
                    <TableCell>{cc.wkz_ziffer || '-'}</TableCell>
                  )}
                  <TableCell>
                    <Chip
                      label={cc.active ? 'Aktiv' : 'Inaktiv'}
                      color={cc.active ? 'success' : 'default'}
                      size="small"
                    />
                  </TableCell>
                  <TableCell align="right">
                    <IconButton size="small" onClick={() => onOpenCallcenterDialog(cc)}>
                      <PencilSimple size={18} />
                    </IconButton>
                    <IconButton size="small" color="error" onClick={() => handleDeleteCallcenter(cc.id)}>
                      <Trash size={18} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
